import { token2CodeApi } from '../action';
import { SUB_URL } from '../const';

function appendCodeToUrl(url: string | undefined, code: string) {
    // 判断 URL 中是否已经有查询参数
    let newUrl;
    if (url?.indexOf('?') === -1) {
        // 没有查询参数，使用 `?` 开始拼接
        newUrl = url + '?code=' + encodeURIComponent(code);
    } else {
        if(url?.split('?')[url?.split('?').length - 1].indexOf('#/') !== -1){
            // 已经有查询参数，使用 `&` 拼接
            newUrl = url + '?code=' + encodeURIComponent(code);
        } else {
            // 已经有查询参数，使用 `&` 拼接
            newUrl = url + '&code=' + encodeURIComponent(code);
        }
    }
    return newUrl;
}

// 获取主站token后同步
const syncSubIframe = async (token: string, target: string | undefined, callback: Function) => {
    // 获取子站code
    const res = await token2CodeApi({
        target: encodeURIComponent(target || '')
    });
    let targetUrl = target;
    if (res.data.code === 0) {
        targetUrl = appendCodeToUrl(target, res.data.data);
    }
    const iframeDom = document.createElement('iframe');
    iframeDom.name = 'sso_page_iframe';
    iframeDom.src = `${SUB_URL}/login/setCookie?token=${token}`;
    iframeDom.style.display = "none";
    document.body.appendChild(iframeDom);
    const fn = (e: any) => {
        if (e.data) {
            try {
                let data = JSON.parse(e.data);
                if (data.from === 'ssoLogin') {
                    switch (data.event) {
                        case 'set_cookie_success':
                            callback(targetUrl);
                            break;
                        case 'set_cookie_error':
                            callback(targetUrl);
                            break;
                        default:
                    }
                }
            } catch (e) {

            }
        }
    }
    window.addEventListener('message', fn);
    iframeDom.addEventListener('error', () => {
        callback(targetUrl);
    })
};

export default syncSubIframe;